(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequiref400"];
var parcelRegister = parcelRequire.register;
parcelRegister("jIj6p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5a0f1bc831a34dc$export$2e2bcd8739ae039; });

var $J7ygF = parcelRequire("J7ygF");

var $hvJJn = parcelRequire("hvJJn");
var $e5a0f1bc831a34dc$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function OptionsSelector(param) {
        var el = param.el;
        (0, $J7ygF._)(this, OptionsSelector);
        this.el = el;
        this.buttons = Array.from(this.el.querySelectorAll('button.level-1'));
        this.sections = Array.from(this.el.querySelectorAll('.option-content-group'));
        this.init();
    }
    (0, $hvJJn._)(OptionsSelector, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                this.buttons.forEach(function(button) {
                    button.addEventListener('click', function() {
                        _this.buttons.forEach(function(button) {
                            return button.classList.remove('active');
                        });
                        button.classList.add('active');
                        var target = button.dataset.title;
                        _this.sections.forEach(function(section) {
                            section.classList.remove('active');
                            if (section.dataset.title === target) section.classList.add('active');
                        });
                    });
                });
            }
        }
    ]);
    return OptionsSelector;
}();

});
parcelRegister("J7ygF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $087a0fb22a93b2d1$export$71511d61b312f219; });
function $087a0fb22a93b2d1$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("hvJJn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cbf8ce221d4c5514$export$71511d61b312f219; });
function $cbf8ce221d4c5514$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cbf8ce221d4c5514$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});


})();
//# sourceMappingURL=OptionsSelector.01895d35.js.map
